
import { ChangeDetectorRef, Component, Inject, OnInit } from "@angular/core";
import { FormControl, Validators } from "@angular/forms";
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from "@angular/material/dialog";
import { MatSelectChange } from "@angular/material/select";
import { MatSnackBar } from "@angular/material/snack-bar";
import { BaseComponent } from "app/base-module/base-component/base.component";
import { AuthService } from "app/base-module/base-service/auth.service";
import { UtilitesService } from "app/base-module/base-service/utilites.service";
import { FileItem, FileUploader } from "ng2-file-upload";
import { TipoBasket } from "../models/tipo-basket";
import { BasketService } from "../services/basket.service";
import { TipoBasketService } from "../services/tipo-basket.service";

export interface DialogData {
    id: number;
} 

@Component({
    selector: "app-upload-basket",
    templateUrl: "./upload-basket.component.html",
    styleUrls: ["./upload-basket.component.scss"]
})

export class UploadBasketComponent extends BaseComponent implements OnInit {

    basket: { id: number } = {
        id: 0
    };

    file: File | null = null;
    nomeFile: string | null = null;
    uploader: FileUploader = new FileUploader({url: ""});
    loadingLocal: boolean = false;
    is_ativo_visible: boolean = false;
    

    tipo_basket_id  = new FormControl("", [Validators.required]);
    rotulo          = new FormControl("", [Validators.required]);   
    ativo           = new FormControl("", []);

    model: {
        tipo_basket_id: string;
        ativo: string;
        rotulo: string;
        nome_arquivo: string;
    } = {
        tipo_basket_id: "",  
        ativo: "",
        rotulo: "",
        nome_arquivo: "",
    };
    
    listTipo: TipoBasket[] = [];

    loadingSpinnerTipo: boolean = false;

    constructor(
        public dialog: MatDialog,
        override snackBar: MatSnackBar,
        public dialogRef: MatDialogRef<UploadBasketComponent>,
        public service: BasketService,
        public utiliesService: UtilitesService,
        public authService: AuthService,
        private changeDetector: ChangeDetectorRef,
        private _service: BasketService,
        private _tipoService: TipoBasketService,
        @Inject(MAT_DIALOG_DATA) public data: DialogData,
    ) {

        super(dialog, snackBar);
       
    }

    ngOnInit() {

        this.nomeFile = null;

        this.uploader = new FileUploader({
            url: this.utiliesService.urlPrefix + "renda-variavel/basket/uploads",
            isHTML5: true,
            authToken: "Bearer " + this.authService.getToken(),           
        });

        
        this.getAllTipos();

        this.uploader.onAfterAddingFile = (file) => { 
            file.withCredentials = false; 
        };
        
        this.uploader.onProgressItem = ( fileItem: FileItem, progress: number ) => { 
            this.changeDetector.detectChanges();
        };
        
        this.uploader.onCompleteItem = (item: FileItem, response: string, status: number, headers: Record<string, string>) => {
        
            this.closeLoading();
            
            if (status == 200){
                var info = JSON.parse(response);
                
                this.showSuccess(info.message);
                
                this.dialogRef.close(info);
            }else{
                var info = JSON.parse(response);               
                this.showError(info.message);      
                this.excluirBasket();
                this.dialogRef.close("cancel");
            }
        
        };
    }

    onNoClick(): void {
        this.dialogRef.close("cancel");
    }

    uploadFile(event: Event) {
        const target = event.target as HTMLInputElement;
        if (target.files && target.files.length > 0) {
            this.file = target.files[0];
            this.nomeFile = this.file?.name || null;
        }
    }

    getAllTipos(){
        
        this.loadingSpinnerTipo = true;
        
        this._tipoService.getAll(this.params).subscribe(
            list => {
                this.loadingSpinnerTipo = false;
                this.listTipo = list.data;
            },
            error => {
                this.loadingSpinnerTipo = false;
            },
            () => {
                this.loadingSpinnerTipo = false;                
            }
        );
    }

    isNomeFile(){
        return (this.nomeFile != null);
    } 

    salvar(){
        this.openLoading();
        this.model.tipo_basket_id   = this.tipo_basket_id.value || "";
        this.model.nome_arquivo     = this.rotulo.value || "";
        
        this._service.create(this.model).subscribe(
            data => {                    
                this.basket = data.data;
            },
            error => {                    
                this.showError(error.error.message);                
            },
            () => {                    
                this.uploader.onBuildItemForm = (fileItem: FileItem, form: FormData) => {
                    form.append("basket_id", this.basket.id.toString());
                    form.append("ativo", this.ativo.value || "");                 
                   };
                this.uploader.uploadAll();                                               
            }
        );

    }

    excluirBasket(){
        this.service.delete(this.basket.id).subscribe(
            data => {
            },
            error => {
            },
            () => { }
        );
    }

    startUpload() {        
        this.salvar();

        
    }

    onTipoBasketChange(event: MatSelectChange) {
        
        const tipoBasket = this.listTipo.find(tipo => tipo.id === event.value);
       
        if(tipoBasket?.estrategia?.is_estruturada) {
           this.is_ativo_visible =true;
        }else{
            this.is_ativo_visible =false;
        }
    }

}

